import ItemCategoryListViewModel from "../view/itemcategorylistviewmodel";
import PagedElements from "./pagedelements";

export default class PagedItemCategories extends PagedElements<ItemCategoryListViewModel> {
    constructor(init?: Partial<PagedItemCategories>) { super(init); }
}